import React, { Component } from 'react';
import { observer } from 'mobx-react';
import KarteStore from '../../store';
import styled from 'styled-components';
import Viewer from '../Viewer';

type Props = {
  karte: KarteStore;
};

@observer
class Viewers extends Component<Props> {
  componentDidMount() {
    this.props.karte.fetchLackData();
  }

  render() {
    switch (this.props.karte.divisionCount) {
      case 1:
        return (
          <HorizontalWrapper>
            <Viewer karteIndex={0} karteStore={this.props.karte} />
          </HorizontalWrapper>
        );
      case 2:
        return (
          <HorizontalWrapper>
            <Viewer karteIndex={0} karteStore={this.props.karte} />
            <Viewer karteIndex={1} karteStore={this.props.karte} />
          </HorizontalWrapper>
        );
      case 3:
        return (
          <HorizontalWrapper>
            <Viewer karteIndex={0} karteStore={this.props.karte} />
            <VerticalWrapper>
              <Viewer karteIndex={1} karteStore={this.props.karte} />
              <Viewer karteIndex={2} karteStore={this.props.karte} />
            </VerticalWrapper>
          </HorizontalWrapper>
        );
      case 4:
        return (
          <HorizontalWrapper>
            <VerticalWrapper>
              <Viewer karteIndex={0} karteStore={this.props.karte} />
              <Viewer karteIndex={1} karteStore={this.props.karte} />
            </VerticalWrapper>
            <VerticalWrapper>
              <Viewer karteIndex={2} karteStore={this.props.karte} />
              <Viewer karteIndex={3} karteStore={this.props.karte} />
            </VerticalWrapper>
          </HorizontalWrapper>
        );
      default:
        return;
    }
  }
}

const HorizontalWrapper = styled.div`
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: row;
`;

const VerticalWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export default Viewers;
